import { Component, Input } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-dashboard-user-access-message',
  templateUrl: './dashboard-user-access-message.component.html',
  styleUrls: ['./dashboard-user-access-message.component.scss'],
})
export class DashboardUserAccessMessageComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  readonly LANG_CONST = LANG_CONST;

  constructor() {}
}
